import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { fetchGraphPersonaNudgeCoupon } from "./nudgeCouponAPI";

const initialState = {
  status: "idle",
  error: null,
  data: {},
  weeks: [],

};

export const graphPersonaNudgeCoupon = createAsyncThunk(
  "nudgeCoupon/visitors",
  async (user, { rejectWithValue }) => {
    try {
      const dbpath = `${user}/graph-couponWise-personaPerformance`;
      const response = await fetchGraphPersonaNudgeCoupon(dbpath, user, "graph-couponWise-personaPerformance");
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const nudgeCouponSlice = createSlice({
  name: "nudgeCoupon",
  initialState,
  reducers: {
    resetCouponWiseData: (state, action) => {
      return { ...initialState };
    }, 
    setUniqueEngaged: (state, action) => {
      state.uniqueEngaged = action.payload;
    },
    setNudgeIdName: (state, action) => { 
      state.nudgeKeyName = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(graphPersonaNudgeCoupon.pending, (state) => {
        state.status = "loading";
      })
      .addCase(graphPersonaNudgeCoupon.fulfilled, (state, action) => {
        state.status = "idle";
        state.error = null;
        const result = action.payload;
        // console.log(result);
        try {
          state.data = result[0];
          state.weeks = Object.keys(result[0]).reverse();

        } catch (error) {
          // console.warn("Persona data not found!", error)
        }

      })
      .addCase(graphPersonaNudgeCoupon.rejected, (state, action) => {
        state.status = "idle";
        state.error = action.payload?.error;
      })
      .addMatcher(
        action => action.type === 'RESET_ALL',
        () => initialState  // Listens for the 'RESET_ALL' action and resets the state
      );
  },
});

export const {resetCouponWiseData, setNudgeIdName} = nudgeCouponSlice.actions;

export const SelectWeeks = (state) => state.nudgeCoupon.weeks;
export const SelectPersonaNudgeCouponStatus = (state) => state.nudgeCoupon.status;


export default nudgeCouponSlice.reducer;
